!function webpackUniversalModuleDefinition(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@wordpress/deprecated"] = r() : (e.wp = e.wp || {}, e.wp.deprecated = r());
}(self, function () {
  return function () {
    "use strict";

    var e = {
      149: function _(e) {
        e.exports = require("@wordpress/hooks");
      }
    },
        r = {};

    function __webpack_require__(t) {
      var o = r[t];
      if (void 0 !== o) return o.exports;
      var n = r[t] = {
        exports: {}
      };
      return e[t](n, n.exports, __webpack_require__), n.exports;
    }

    var t = {};
    return function () {
      var e = t;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = function deprecated(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

        var n = t.since,
            i = t.version,
            d = t.alternative,
            s = t.plugin,
            p = t.link,
            c = t.hint,
            a = s ? " from ".concat(s) : "",
            u = n ? " since version ".concat(n) : "",
            l = i ? " and will be removed".concat(a, " in version ").concat(i) : "",
            f = d ? " Please use ".concat(d, " instead.") : "",
            _ = p ? " See: ".concat(p) : "",
            v = c ? " Note: ".concat(c) : "",
            $ = "".concat(e, " is deprecated").concat(u).concat(l, ".").concat(f).concat(_).concat(v);

        if ($ in o) return;
        (0, r.doAction)("deprecated", e, t, $), console.warn($), o[$] = !0;
      }, e.logged = void 0;

      var r = __webpack_require__(149);

      var o = Object.create(null);
      e.logged = o;
    }(), t;
  }();
});